import { ButtonProps, Root } from './Button.ui';

export const Button = (props: ButtonProps) => {
  const { active, children, className, tabIndex = 0, ...rest } = props;

  return (
    <Root active={active} className={className} tabIndex={tabIndex} {...rest}>
      {children}
    </Root>
  );
};
